import type {
  Rule,
  GetRulesRequest,
  CreateRuleRequest,
  UpdateRuleRequest,
} from '@/apis/generated/dialbunny';
import { RuleFromJSON } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type RuleStore = StoreEntity<
  Rule,
  'id',
  GetRulesRequest,
  CreateRuleRequest['rulePost'],
  UpdateRuleRequest['rulePatch']
>;

export const useRuleStore = apiStoreFactory<
  RuleStore['entity'],
  RuleStore['id'],
  RuleStore['filter'],
  RuleStore['createInput'],
  RuleStore['updateInput']
>(
  STORE.RULE,
  { entityIdKey: 'id' },
  {
    create: async (ruleCreate, { dialbunnyApi }) => {
      return await dialbunnyApi.createRule({
        rulePost: ruleCreate,
      });
    },
    read: async (ruleId, { dialbunnyApi }) => {
      return await dialbunnyApi.getRule({ ruleId });
    },
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getRulesRaw(filter, { signal });
    },
    update: async (ruleId, rulePatch, { dialbunnyApi }) => {
      return await dialbunnyApi.updateRule({ ruleId, rulePatch });
    },
    discard: async (ruleId, { dialbunnyApi }) => {
      await dialbunnyApi.deleteRule({
        ruleId,
      });
    },
    bulkRead: async (ruleIds, { dialbunnyApi }) => {
      const rules = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Rule',
        ids: ruleIds.join(','),
      });
      return rules.map(RuleFromJSON);
    },
  },
);
